export enum QueueStrategy {
  /**
   * standard queue strategy the task
   * are executed in the order they are enqueued
   */
  FIFO,

  /**
   * execute only the last task enqueued
   * discarding the other ones
   */
  Latest,
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type QueueFunc = () => Promise<any>

export class Queue {
  private readonly strategy: QueueStrategy
  private queue: QueueFunc[]
  private running: boolean
  private idleWaiters: Array<() => void>

  constructor(strategy: QueueStrategy) {
    this.strategy = strategy
    this.queue = []
    this.running = false
    this.idleWaiters = []
  }

  /**
   * enqueue a task in the queue base
   * it will be executed based on the QueueStrategy
   * @param func the task to enqueue
   */
  public enqueue(func: QueueFunc): void {
    const wrapped = async () => {
      try {
        await func()
        this.next()
      } catch (error) {
        console.error(error)
        this.next()
      }
    }

    this.queue.push(wrapped)
    if (!this.running) this.next()
  }

  public whenIdle(): Promise<void> {
    if (!this.running && !this.queue.length) {
      return Promise.resolve()
    }

    return new Promise((resolve) => {
      this.idleWaiters.push(resolve)
    })
  }

  private next(): void {
    this.running = false
    const nextItem = QueueStrategy.Latest ? this.queue.pop() : this.queue.shift()

    if (this.strategy === QueueStrategy.Latest) this.queue = []

    if (nextItem) {
      this.running = true
      nextItem()
    } else {
      this.idleWaiters.splice(0).forEach((resolve) => resolve())
    }
  }
}
